import { Button, Group, Text } from "@mantine/core";
import { ConfirmAndExecutePanel, EntityClientAction } from "@mcurros2/microm";
import { IconAlertCircle } from "@tabler/icons-react";
import { DatosServiciosGestion } from "../DatosServiciosGestion/DatosServiciosGestion";
import { DatosServiciosAutorizacion } from "./DatosServiciosAutorizacion";

export const ACTCheckout: EntityClientAction = {
    name: 'ACTCheckout',
    label: 'Checkout',
    title: <Text fw={700}>Checkout</Text>,
    refreshOnClose: true,
    dontRequireSelection: false,
    minSelectedRecords: 1,
    maxSelectedRecords: 1,
    views: [
        'dasa_brwGestionReportes',
        'dasa_brwGestionReportesVisitasIniciadas',
        'dasa_brwGestionReportesVisitasEnProceso',
        'dasa_brwGestionReportesVisitasFinalizadas',
        'dasa_brwGestionReportesVisitasIniciadasAppSupervisor',
        'dasa_brwGestionReportesVisitasEnProcesoAppSupervisor',
        'dasa_brwGestionReportesVisitasFinalizadasAppSupervisor'
    ],    showActionInViewMode: true,
    onClick: async ({ entity, modal, selectedKeys, element, onClose }) => {

        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }

        const parent = entity as DatosServiciosAutorizacion;
        const datosServiciosGestion = new DatosServiciosGestion(entity.API.client);
        datosServiciosGestion.parentKeys = parent.parentKeys;

        const procParms = {
            c_visita_id: selectedKeys?.[0]?.['c_visita_id'] ?? ''
        };

        let errores = '';

        if (!procParms.c_visita_id) {
            errores = 'Los registros seleccionados son inválidos';
        }

        if (errores) {
            await modal.open({
                modalProps: {
                    title: <Group><IconAlertCircle size="1.5rem" stroke="1.5" /> <Text fw="700">ERROR</Text></Group>,
                },
                focusOnClosed: element,
                content:
                    <>
                        <Text size="sm" mb="xs">
                            {errores}
                        </Text>
                        <Group mt="xs" position="right">
                            <Button onClick={async () => await modal.close()}>Cerrar</Button>
                        </Group>
                    </>
            });

        }
        else {
            const abort_controller = new AbortController();

            await modal.open({
                modalProps: {
                    title: <Text fw="700">Checkout</Text>
                },
                focusOnClosed: element,
                content: <ConfirmAndExecutePanel
                    content={<Text size="sm" mb="xs">Va a realizar el checkout de la visita. ¿Está seguro?</Text>}
                    operation="proc"
                    onCancel={async () => { await abort_controller.abort(); await modal.close(); }}
                    onOK={
                        async () => {
                            const result = await datosServiciosGestion.API.executeProcess(datosServiciosGestion.def.procs.dasg_checkoutPorVisita, procParms, abort_controller.signal);
                            const success = result.Failed === false;
                            if (onClose) await onClose(success);
                            if (success) await modal.close();
                            return result;
                        }
                    }
                />

            });
        }

        return false;
    }
}